export default __webpack_public_path__ + "static/media/my-reddit-header.c57d5da3.jpg";